/**
 * hasPermissionsTo returns whether the current auth user
 * has the specified array of string permissions.
 * 
 * Returns true if ALL permissions are present, 
 * or false otherwise.
 * 
 * @param {String[]} permissions
 * @returns {Boolean}
 */
export const hasPermissionsTo = (state) => (permissions) => {
  const user = state.user;
  if (!user) {
    return false;
  }

  const permissionMatches = permissions.filter(
    permission => user.permissions.includes(permission)
  );

  return permissionMatches.length === permissions.length;
};
